var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stockByCustomer"},[_c('div',{staticClass:"content-view"},[_c(_vm.nodeInfo,{tag:"component",attrs:{"auth":_vm.nodeAuth}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }